<script lang="ts">
    import { goto } from "../../utils.js";
    import { onMount } from "svelte";

    const {
        route,
        params,
        query,
        replace = false,
    }: {
        route: string;
        params?: Record<string, string | string[]>;
        query?: Record<string, string | string[]>;
        replace?: boolean;
    } = $props();

    onMount(() => {
        goto({ route, params, query, replace });
    });
</script>
